import styles from "../../../styles/components/UI/Custom/Wrapper.module.css"
import React from 'react'


export const Wrapper = ({ children, top_bottom = 0, right_left = 0 }) => {
    return (
        <div
            style={{
                padding: `${top_bottom}em ${right_left}em`,

                height: `100vh`
            }}
        >
            {children}
        </div>
    )
}